import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { ModalController, Platform, PopoverController, AlertController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { IssueSupplier, IssuesFilterSupplier, Proforma } from '@arpada/arp-lib-common-qupro';
import { Subscription } from 'rxjs';

import { PortalProveedorService, UiService } from '../../../../services/api.services';
import { ModeloError } from '../../../../models/api.models';

import { AsignarOperarioComponent } from '../../operario/asignar-operario/asignar-operario.component';
import { DescargaHojasTrabajoComponent } from '../../descarga-hojas-trabajo/descarga-hojas-trabajo.component';
import { ActionsSharedData } from '../actions.shared.data';
import { EdicionMasivaComponent } from '../../edicion-masiva/edicion-masiva.component';
import { IssuesErrorComponent } from '../../edicion-masiva/issues-error/issues-error.component';

@Component({
  selector: 'app-more-actions-issues',
  templateUrl: './more-actions-issues.component.html',
  styleUrls: ['./more-actions-issues.component.scss'],
})
export class MoreActionsIssuesComponent implements OnInit, OnDestroy {

  @Input() showListButton: boolean;
  @Input() showCardListButton: boolean;
  @Input() showEditOperarioButton: boolean;
  @Input() issuesToEdit: IssueSupplier[];
  @Input() isPopover: boolean;

  @Input() comeFromIssue: boolean;
  @Input() issuesSelected: boolean;
  @Input() sharedData: ActionsSharedData;
  @Input() idsFilterIssues: number[];
  @Input() filter: IssuesFilterSupplier; // son mis filtros y order de la lib
  @Input() mode: string;

  @Input() showInlineEditButton: boolean;
  @Input() showExitInlineEditButton: boolean;
  @Input() showInlineEditionMenu: boolean;

  @Input() postsaleFilter: boolean;
  @Input() presaleFilter: boolean;

  @Input() showEdMasivaButton: boolean;
  @Input() showEdMasivaErrorButton: boolean;
  @Input() edMasivaErrors: ModeloError[];

  @Input() showCreateProformaButton: boolean;
  @Input() comeFromProforma: boolean;
  @Input() proformasToExport: Proforma[];

  @Input() totalCountIssuesToSelect: number;
  @Input() showSelectAllCards: boolean;
  @Input() allCardsSelectButton: boolean;
  @Input() canFirmIssues: boolean;

  @Input() comeFromConforme: boolean;

  @Output() public listPressed = new EventEmitter();
  @Output() public cardListPressed = new EventEmitter();
  @Output() public inlineEditPressed = new EventEmitter();
  @Output() public exitInlineEditPressed  = new EventEmitter();
  @Output() public exitEdMasivaErrorPressed  = new EventEmitter();
  @Output() public createProformaPressed  = new EventEmitter();
  @Output() public exportProformasPressed  = new EventEmitter();
  @Output() public selectAllPressed  = new EventEmitter();
  @Output() public firmIssuesEvent  = new EventEmitter();
  @Output() public uploadAgreementPressed  = new EventEmitter();

  showBackButton = false;
  selected = false;
  proformasCount = 0;
  private selectionAllCardsSubscription: Subscription;

  constructor(private modalCtrl: ModalController,
              private popoverCtrl: PopoverController ,
              public platform: Platform,
              public alertController: AlertController,
              private translate: TranslateService,
              private uiService: UiService,
              private portalProveedorService: PortalProveedorService
  ) { }

  ngOnDestroy(): void {
    if (this.selectionAllCardsSubscription) {
      this.selectionAllCardsSubscription.unsubscribe();
    }
  }

  ngOnInit() {
    if (this.platform.is('desktop')) {
      this.showBackButton = false;
    }
    if (this.proformasToExport) {
      if (this.proformasToExport.length > 0) {
        this.proformasCount = this.proformasToExport.length;
      }
    }
    this.selectionAllCardsSubscription = this.portalProveedorService.selectionAllCardsEvent.subscribe((select: boolean) => {
      this.allCardsSelectButton = !select;
      this.idsFilterIssues = this.sharedData.issuesFrontIdsSelected;
      this.issuesSelected = select;
    });
    if (this.sharedData && this.sharedData.issuesFrontIdsSelected && this.sharedData.issuesFrontIdsSelected.length > 0) {
      this.idsFilterIssues = this.sharedData.issuesFrontIdsSelected;
      this.sharedData.idsSelected = this.sharedData.issuesFrontIdsSelected.length + '';
      this.issuesSelected = true;
    }
  }

  selectAll(ev: Event) {
    if (Number(this.totalCountIssuesToSelect) > 100) {
      const mms = 'No puede seleccinar más de 100 incidencias';
      this.uiService.showSimpleMiddleToast(mms, 2000);
      this.issuesSelected = false;
    } else {
      this.selectAllPressed.emit(true);
      this.issuesSelected = true;
    }
  }

  deselectAll(ev: Event) {
    this.selectAllPressed.emit(false);
  }

  onListPressed(event: Event) {
    this.showCardListButton = true;
    this.showListButton = false;
    localStorage.setItem('modoVista', 'escritorio');
    this.listPressed.emit(event);
    this.dismiss();
  }

  onCardListPressed(event: Event) {
    this.showCardListButton = false;
    this.showListButton = true;
    localStorage.setItem('modoVista', 'cards');
    this.cardListPressed.emit(event);
    this.dismiss();
  }

  onInlineEditPressed(event: Event) {
    this.inlineEditPressed.emit(true);
    this.dismiss();
  }

  onExitInlineEditPressed(event: Event) {
    this.exitInlineEditPressed.emit(true);
    this.dismiss();
  }

  async editarOperario() {
    const modal = await this.modalCtrl.create({
      component: AsignarOperarioComponent,
      componentProps: {
        issuesToEdit: this.issuesToEdit,
        isModal: true,
        postsaleFilter: this.postsaleFilter,
        presaleFilter: this.presaleFilter
      }
    });
    this.dismiss();
    return await modal.present();
  }

  async openAllDownloadFiles(event, param: string) {
    if (this.filter.csite_id != null) {
      const popover = await this.popoverCtrl.create({
        component: DescargaHojasTrabajoComponent,
        event,
        componentProps: {
          sharedData: this.sharedData,
          filter: this.filter,
          mode: this.mode
        }
      });
      return await popover.present();
    } else {
      const alert = await this.alertController.create({
        header: this.translate.instant('components.shared.actionsHeader.moreActions.alertTitle'),
        message: this.translate.instant('components.shared.actionsHeader.moreActions.alertMms'),
        buttons: [this.translate.instant('components.shared.actionsHeader.moreActions.alertOkButton')]
      });
      await alert.present();
    }
  }

  async openSelectedDownloadFiles(event, param: string) {
    if (param === 'selected') {
      this.selected = true;
    }
    if (this.filter.csite_id === null) {
      const alert = await this.alertController.create({
        header: this.translate.instant('components.shared.actionsHeader.moreActions.alertTitle'),
        message: this.translate.instant('components.shared.actionsHeader.moreActions.alertMms'),
        buttons: [this.translate.instant('components.shared.actionsHeader.moreActions.alertOkButton')]
      });
      await alert.present();
    }

    if (!this.issuesSelected) {
      const alert = await this.alertController.create({
        header: this.translate.instant('components.shared.actionsHeader.moreActions.alertTitle'),
        message: this.translate.instant('components.shared.actionsHeader.moreActions.alertMms2'),
        buttons: [this.translate.instant('components.shared.actionsHeader.moreActions.alertOkButton')]
      });
      await alert.present();
    }
    if (this.filter.csite_id != null && this.issuesSelected) {
      const popover = await this.popoverCtrl.create({
        component: DescargaHojasTrabajoComponent,
        event,
        componentProps: {
          sharedData: this.sharedData,
          filter: this.filter,
          idsFilterIssues: this.idsFilterIssues,
          selected: this.selected,
          mode: this.mode
        }
      });
      return await popover.present();
    }
  }

  async edicionMasiva($event) {
    const modal = await this.modalCtrl.create({
      component: EdicionMasivaComponent,
      componentProps: {
        issuesToEdit: this.issuesToEdit,
        isModal: true,
        postsaleFilter: this.postsaleFilter,
        presaleFilter: this.presaleFilter
      }
    });
    this.dismiss();
    return await modal.present();
  }

  async openEdMasivaError($event) {
    const modal = await this.modalCtrl.create({
      component: IssuesErrorComponent,
      componentProps: {
        errors: this.edMasivaErrors,
        isModal: true,
        exitEdMasivaErrorPressed: this.exitEdMasivaErrorPressed
      }
    });
    this.dismiss();
    return await modal.present();
  }

  async createProforma(event: Event) {
    this.createProformaPressed.emit(true);
    this.dismiss();
  }

  async exportProformasSelected() {
    if (this.proformasToExport && this.proformasToExport.length > 0) {
      this.exportProformasPressed.emit(this.proformasToExport);
    } else {
      const alert = await this.alertController.create({
        header: this.translate.instant('components.shared.actionsHeader.moreActions.alertTitle'),
        message: this.translate.instant('components.shared.actionsHeader.moreActions.alertProformaMms'),
        buttons: [this.translate.instant('components.shared.actionsHeader.moreActions.alertOkButton')]
      });
      await alert.present();
    }
  }

  async firmar(ev: Event) {
    if (!this.issuesSelected) {
      const alert = await this.alertController.create({
        header: this.translate.instant('components.shared.actionsHeader.moreActions.alertTitle'),
        message: this.translate.instant('components.shared.actionsHeader.moreActions.alertMms2'),
        buttons: [this.translate.instant('components.shared.actionsHeader.moreActions.alertOkButton')]
      });
      await alert.present();
    } else {
      this.firmIssuesEvent.emit(this.idsFilterIssues);
    }
  }

  async uploadAgreement(event: Event) {
    this.uploadAgreementPressed.emit(true);
    this.dismiss();
  }

  exit() {
    this.dismiss();
  }

  private dismiss() {
    this.popoverCtrl.dismiss();
  }

}
